import { render, staticRenderFns } from "./PersonStatutoryInfoEdit.vue?vue&type=template&id=69bbc004"
import script from "./PersonStatutoryInfoEdit.vue?vue&type=script&lang=js"
export * from "./PersonStatutoryInfoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports